// extracted by mini-css-extract-plugin
export default {"fieldBaseTheme":"dataEntry__fieldBaseTheme___GeIks"};